import { validationTypes } from "../../../components/forms/libs/data/ValidationTypes";
import { FileFormats } from "../../../components/forms/libs/data/fileFormatTypes";
import { FormFieldTypes } from "../../../components/forms/libs/data/formFieldType";
import { ImageFormats } from "../../../components/forms/libs/data/imageFormatTypes";
import TitleWrapper from "../../../components/ui/titlewrapper/TitleWrapper";

const initState = {
  name: '',
  entryType: null,
  displayEventImage: null,
  flagTag: '',
  entryTopic: '',
  isApproval: 'Yes',
  notificationPeriod: null,
  about: '',
  outlines: '',
  speaker: '',
  displaySpeakerImage: null,
  readMore: '',
};

export const BasicInformationData = {
  name: "EditMembershipTaskListFormData",
  initialState: initState,
  section: [
    {
      title: "Basic Information Section",
      row: {},
      style: {
        sectionStyle: "verticle-form mb-3 form-card row",
      },
      wrapperTemplate: <TitleWrapper title="Basic Information" />,
      fields: [
        {
          id: "name ",
          label: "Entry Name",
          Field_Name: "Name",
          fieldType: FormFieldTypes.INPUT,
          dataField: "name",
          fieldSetting: {
            placeholder: "Please Enter Name",
            allowSpace: true,
            textareaRows: 4,
          },
          style: {
            containerCss: "col-lg-4 col-md-4 validation-left-0 mb-2",
          },
        },
        {
          id: "entryType",
          label: "Entry Type",
          Field_Name: "Entry Type",
          fieldType: FormFieldTypes.SELECT,
          dataField: "entryType",
          fieldSetting: {
            placeholder: "Select",
            allowSpace: true,
            isDisable: false,
            options: [],
          },
          style: {
            containerCss: "col-lg-4 col-md-4 validation-left-0",
          },
        },
        {
          id: "displayEventImage",
          label: "Upload Event Image (please upload in jpg/png format max 2mb)",
          Field_Name: "Upload Event Image",
          fieldType: FormFieldTypes.IMAGE,
          dataField: "displayEventImage",
          fieldSetting: {
            placeholder: "Display Image",
            allowMultipleFiles: false,
            acceptedImageFormats: [
              ImageFormats.JPEG,
              ImageFormats.BMP,
              ImageFormats.JPG,
              ImageFormats.PNG,
              ImageFormats.WEBP,
            ],
            minFileSizeInMB: 0, // Minimum File size in MB
            maxFileSizeInMB: 8, // Maximum File size in MB
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 col-md-4 validation-text-fileuploader",
          },
        },
        {
          id: "flagTag",
          label: "Workshop Flag Tag",
          Field_Name: "Workshop Flag Tag",
          fieldType: FormFieldTypes.INPUT,
          dataField: "flagTag",
          fieldSetting: {
            placeholder: "Please Enter Name",
            allowSpace: true,
            textareaRows: 4,
          },
          style: {
            containerCss: "col-lg-4 col-md-4 validation-left-0 mb-2",
          },
        },
        {
          id: "entryTopic",
          label: "Entry Topic (You can select more than one option)",
          Field_Name: "Entry Topic",
          fieldType: FormFieldTypes.SELECT,
          dataField: "entryTopic",
          fieldSetting: {
            placeholder: "Select",
            allowSpace: true,
            isDisable: false,
            options: [
              // { label: "City 1", value: 1 },
              // { label: "City 2", value: 2 },
              // { label: "City 3", value: 3 },
            ],
          },
          style: {
            containerCss: "col-lg-4 col-md-4 validation-left-0",
          },
        },
        {
          id: "",
          Field_Name: "",
          fieldType: FormFieldTypes.DATEPICKER,
          label: "",
          dataField: "",

          style: {
            containerCss: "col-lg-4 col-md-4 blank-field blank-field-with-btn",
          },
        },
        {
          id: "isApproval",
          label: "Registration Approval",
          Field_Name: "Registration Approval",
          fieldType: FormFieldTypes.RADIOBUTTON,
          dataField: "isApproval",
          fieldSetting: {
            allowSpace: true,
            options: [
              { value: "yes", label: "Yes" },
              { value: "no", label: "No" },
            ],
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 radioStyle col-md-4 ",
          },
        },
        {
          id: "about",
          label: "About",
          Field_Name: "About",
          fieldType: FormFieldTypes.TEXTEDITOR,
          dataField: "about",
          fieldSetting: {
            allowSpace: true,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-xxl-12 col-xl-12 col-md-12 col-12 mt-4",
          },
        },
        {
          id: "outlines",
          label: "Outlines",
          Field_Name: "Outlines",
          fieldType: FormFieldTypes.TEXTEDITOR,
          dataField: "outlines",
          fieldSetting: {
            allowSpace: true,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-xxl-12 col-xl-12 col-md-12 col-12 mt-4",
          },
        },
        {
          id: "speaker",
          label: "Speaker",
          Field_Name: "Speaker",
          fieldType: FormFieldTypes.TEXTEDITOR,
          dataField: "speaker",
          fieldSetting: {
            allowSpace: true,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-xxl-8 col-xl-8 col-md-8 col-8 mt-4",
          },
        },
        {
          id: "displaySpeakerImage",
          label: "Upload Speaker Image",
          Field_Name: "Upload Event Image",
          fieldType: FormFieldTypes.IMAGE,
          dataField: "displaySpeakerImage",
          fieldSetting: {
            placeholder: "Display Image",
            allowMultipleFiles: false,
            acceptedImageFormats: [
              ImageFormats.JPEG,
              ImageFormats.BMP,
              ImageFormats.JPG,
              ImageFormats.PNG,
              ImageFormats.WEBP,
            ],
            minFileSizeInMB: 0, // Minimum File size in MB
            maxFileSizeInMB: 8, // Maximum File size in MB
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 col-md-4 validation-text-fileuploader mt-5",
          },
        },
        {
          id: "readMore",
          label: "Read More",
          Field_Name: "Read More",
          fieldType: FormFieldTypes.TEXTEDITOR,
          dataField: "readMore",
          fieldSetting: {
            allowSpace: true,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-xxl-12 col-xl-12 col-md-12 col-12 mt-4",
          },
        },
      ],
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};
